var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "emd-stone-rebrand-secure-env" },
        [
          _c("logo-stone-rebrand-icon", {
            staticClass: "emd-stone-rebrand-secure-env__icon",
            staticStyle: { width: "16px", height: "16px" },
          }),
          _c("span", { staticClass: "emd-stone-rebrand-secure-env__brand" }, [
            _vm._v("Stone"),
          ]),
          _c("span", { staticClass: "emd-stone-rebrand-secure-env__label" }, [
            _vm._v(_vm._s(_vm.$t("secureEnvironment"))),
          ]),
        ],
        1
      ),
      _c("emd-footer-internal", {
        attrs: {
          switchLanguage: _vm.switchLanguage,
          switchThemeMode: _vm.switchThemeMode,
          privacySecurity: _vm.privacySecurity,
          help: _vm.help,
          termsOfUse: _vm.termsOfUse,
          privacyPolicy: _vm.privacyPolicy,
          secureEnv: _vm.secureEnv,
          documentation: _vm.documentation,
          status: _vm.status,
          listStyle: _vm.listStyle,
        },
        on: {
          changeLanguage: _vm.changeLanguage,
          changeThemeMode: _vm.changeThemeMode,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }